module.exports = __webpack_public_path__ + "static/media/johan.a13738e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/johan.jpg
// module id = 94
// module chunks = 0